import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AboutHeroSection from './components/AboutHeroSection';
import AboutWhoWeAreSection from './components/AboutWhoWeAreSection';
import AboutMissionSection from './components/AboutMissionSection';
import AboutTeamSection from './components/AboutTeamSection';
import AboutBenefitsSection from './components/AboutBenefitsSection';

export default function AboutPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-background-50">
        <AboutHeroSection />
        <AboutWhoWeAreSection />
        <AboutMissionSection />
        <AboutTeamSection />
        <AboutBenefitsSection />
      </main>
      <Footer />
    </>
  );
}